<template>
  <div id="cookie-policy">
    <div class="scroller" style="height: 500px">
      <h6>INTRODUCTION</h6>
      <p>
        We may use cookies, web beacons, tracking pixels, and other tracking
        technologies when you visit our website Online Media Monitoring,
        including any other media form, media channel, mobile website, or mobile
        application related or connected there to (collectively, the “Site”) to
        help customize the Site and improve your experience.
      </p>
      <p>
        We reserve the right to make changes to this Cookie Policy at any time
        and for any reason. We will alert you about any changes by updating the
        “Last Updated” date of this Cookie Policy. Any changes or modifications
        will be effective immediately upon posting the updated Cookie Policy on
        the Site, and you waive the right to receive specific notice of each
        such change or modification.
      </p>
      <p>
        You are encouraged to periodically review this Cookie Policy to stay
        informed of updates. You will be deemed to have been made aware of, will
        be subject to, and will be deemed to have accepted the changes in any
        revised Cookie Policy by your continued use of the Site after the date
        such revised Cookie Policy is posted.
      </p>
      <p>
        This Cookie Policy was generated by Termly’s Cookie Consent Manager.
      </p>

      <h6>USE OF COOKIES</h6>
      <p>
        A “cookie” is a string of information which assigns you a unique
        identifier that we store on your computer. Your browser then provides
        that unique identifier to use each time you submit a query to the Site.
        We use cookies on the Site to, among other things, keep track of
        services you have used, record registration information, record your
        user preferences, keep you logged into the Site, facilitate purchase
        procedures, and track the pages you visit. Cookies help us understand
        how the Site is being used and improve your user experience.
      </p>

      <h6>TYPES OF COOKIES</h6>
      <p>The following types of cookies may be used when you visit the Site:</p>

      <h6>Analytics Cookies</h6>
      <p>
        Analytics cookies monitor how users reached the Site, and how they
        interact with and move around once on the Site. These cookies let us
        know what features on the Site are working the best and what features on
        the Site can be improved.
      </p>

      <h6>Our Cookies</h6>
      <p>
        Our cookies are “first-party cookies”, and can be either permanent or
        temporary. These are necessary cookies, without which the Site won’t
        work properly or be able to provide certain features and
        functionalities. Some of these may be manually disabled in your browser,
        but may affect the functionality of the Site.
      </p>

      <h6>Personalization Cookies</h6>
      <p>
        Personalization cookies are used to recognize repeat visitors to the
        Site. We use these cookies to record your browsing history, the pages
        you have visited, and your settings and preferences each time you visit
        the Site.
      </p>

      <h6>Security Cookies</h6>
      <p>
        Security cookies help identify and prevent security risks. We use these
        cookies to authenticate users and protect user data from unauthorized
        parties.
      </p>

      <h6>Site Management Cookies</h6>
      <p>
        Site management cookies are used to maintain your identity or session on
        the Site so that you are not logged off unexpectedly, and any
        information you enter is retained from page to page. These cookies
        cannot be turned off individually, but you can disable all cookies in
        your browser.
      </p>

      <h6>Third-Party Cookies</h6>
      <p>
        Third-party cookies may be place on your computer when you visit the
        Site by companies that run certain services we offer. These cookies
        allow the third parties to gather and track certain information about
        you. These cookies can be manually disabled in your browser.
      </p>
    </div>
    <div class="row m-t-20">
      <div class="col-12" align="right">
        <button class="btn btn-sm btn-primary" data-dismiss="modal">
          Tutup & Terima Cookie
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "modal_cookie_policy",
};
</script>